import {useEffect} from 'react';
import ProjectCreationProgressTracker from '../../components/ProjectCreationProgressTracker';
import ProjectProgressHeaderContent from '../../components/ProjectProgressHeaderContent';
import BackToClientButton from '../../components/BackToClientButton';

interface Props {
  projectName: string;
}

const Confirmation: React.FC<Props> = ({projectName}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="project-create-confirmation-container">
      <ProjectProgressHeaderContent projectName={projectName} />
      <div className="progress-tracker-container">
        <ProjectCreationProgressTracker progressType='new-project-created' />
      </div>
      <BackToClientButton />
    </div>
  );
};

export default Confirmation;
